import {
    getOrganization,
    listOrganizations
} from './queries';
import {
    createOrganization,
    deleteOrganization,
    updateOrganization,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CreateOrganization,
    DeleteOrganization,
    GetOrganization,
    ListOrganizations,
    Organization,
    UpdateOrganization
} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../../components/PlatformNotification";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (filter: { [k: string]: string }) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListOrganizations>>(
            {
                query: listOrganizations,
                variables: {
                    filter: filter,
                    limit: 100,
                    nextToken: null
                },
            });
        return response.data?.listOrganizations.items;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetOrganization>>({
                                                                                 query: getOrganization,
                                                                                 variables: {id: id},
                                                                             });
        return response.data?.getOrganization;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateOrganization>>({
                                                                                    query: createOrganization,
                                                                                    variables: {input: payload},
                                                                                });
        console.debug('in the service response', response);

        notifySuccess();
        return response.data?.createOrganization;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (_id: string, record: Organization) => {

    console.debug('IN UPDATE', _id, record);

    const {id, name, description, adminAccountId, url, email, phone, organizationStatus} = record;
    const input = {id, name, description, adminAccountId, url, email, phone, organizationStatus};

    try {
        const response = await client.graphql<GraphQLQuery<UpdateOrganization>>({
                                                                                    query: (updateOrganization),
                                                                                    variables: {input},
                                                                                });

        notifySuccess();
        return response.data?.updateOrganization;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteOrganization>>({
                                                                                    query: (deleteOrganization),
                                                                                    variables: {input: {id: id}},
                                                                                });
        notifySuccess();
        return response.data?.deleteOrganization;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};
